// import jQuery from 'jquery';
import './module/jquery.pjax.js';
// import 'swiper/css';
// import 'swiper/css/pagination';
// import 'swiper/css/effect-fade';
// import Swiper, { Pagination, Autoplay, EffectFade } from 'swiper';
// Swiper.use([Pagination, Autoplay, EffectFade]);
import {
	page_anime_func,
	slider_top,
	ttl_pjax_anim,
	pjax_anim_01,
	pjax_anim_ringOpen,
	pjax_anim_02,
} from './pjax_function';
import { mainSlider, top_swiper_destroy, top_swiper } from './swiper';
import { gsap } from 'gsap';

const OBSERVER = {
	// handlers: [],//error
	handlers: Array(),
	observeEvents: function (targets) {
		this.handlers.push(targets);
	},
	clearEvents: function () {
		const _self = this;
		function loop(i) {
			return new Promise(function (resolve, reject) {
				let events = _self.handlers[i];
				for (var j = events.length - 1; j >= 0; j--) {
					let remEv = events[j];
					$(remEv[0]).off(remEv[1]);
				}
				_self.handlers.splice(i, 1);
				resolve(i++);
			}).then(function (count: any) {
				///unknown -> any ???
				if (count > _self.handlers.length - 1) {
					loop(count);
				}
			});
		}
		loop(0);
	},
};
/* Events Detail */
var _MenuButton = document.getElementsByClassName('js-menu-toggle');
var _state = false;
var _dataAsClick;
var _scrollfromTop; ////

window.addEventListener('load', function () {
	_scrollfromTop =
		document.documentElement.scrollTop || document.body.scrollTop;
});
function menu_init() {
	for (var $i = 0; $i < _MenuButton.length; $i++) {
		_MenuButton[$i].addEventListener(
			'click',
			function () {
				_scrollfromTop =
					document.documentElement.scrollTop || document.body.scrollTop;
				document.body.classList.toggle('js-menu_active');
				if (_state == false) {
					_dataAsClick = _scrollfromTop;
					document.documentElement.style.height = 'auto';
					document.body.style.top = -_dataAsClick + 'px';
					_state = true;
				} else {
					document.documentElement.style.height = '100%';
					document.body.style.top = '0px';
					window.scrollTo(0, _dataAsClick);
					_state = false;
				}
			},
			false
		);
	}
}

let scroll_event =
	'onwheel' in document
		? 'wheel'
		: 'onmousewheel' in document
		? 'mousewheel'
		: 'DOMMouseScroll';
function no_scroll() {
	$(document).on(scroll_event, function (e) {
		e.preventDefault();
	});

	$(document).on('touchmove.noScroll', function (e) {
		e.preventDefault();
	});
}

function return_scroll() {
	$(document).off(scroll_event);
	$(document).off('.noScroll');
}
function openingAnimation() {
	window.setTimeout(() => {
		document.body.classList.remove('non-scrollable');
	}, 2600);
	window.setTimeout(() => {
		window.scrollTo(0, -1);
		document.body.classList.add('non-scrollable');
		document.documentElement.scrollTop = 0;
	}, 1000);
	window.setTimeout(() => {}, 2000);
}

function handleTouchMove(event) {
	event.preventDefault();
}

function scroll_reset() {
	$(window).off('scroll');
	document.body.style.top = '';
}

let run_one_func = 0;
let timerID;

// function scrollEv() {
// 	let scroll_Top = 0;
// 	const bottomItems = document.querySelectorAll('.js-next_page');
// 	//.js-next_pageが100％rootないに移ったら
// 	const IntersectionObserverOptions = {
// 		root: null, // ビューポートはウィンドウ全体
// 		rootMargin: '40px 0px 40px 0px',
// 		threshold: 1, //
// 	};
// 	const observer = new IntersectionObserver(
// 		IntersectFunction,
// 		IntersectionObserverOptions
// 	);
// 	bottomItems.forEach((item) => {
// 		observer.observe(item);
// 	});

// 	$(window).on('touchend scroll', function (e) {
// 		//旧スクロールイベント用
// 		var doch = $(document).innerHeight();
// 		var winh = $(window).innerHeight();
// 		var bottom = doch - winh;
// 		var scrollHeight = $(document).height();
// 		var scrollPosition = $(window).height() + $(window).scrollTop();
// 		scroll_Top = $(window).scrollTop();

// 		if (popstateFlag === 1) {
// 			popstateFlag = 0;
// 			run_one_func = 0;
// 			// current_data = $('.js-next_page').data('link');
// 			// current_link = link_array[current_data].json;
// 			$('body').removeClass('js-pjax_pop');
// 		} else {
// 			if (
// 				!$('#page_about').length &&
// 				run_one_func == 0 &&
// 				bottom - 150 <= scroll_Top //***
// 			) {
// 				if (!$('.js-pjax_pop').length && run_one_func === 0) {
// 					run_one_func = 1;
// 				}
// 			}
// 		}
// 	});
// 	function IntersectFunction(elements) {
// 		//自動遷移pjax
// 		// 交差監視をしたもののなかで、isIntersectingがtrueになったとき
// 		elements.forEach((element) => {
// 			if (element.isIntersecting) {
// 			//	console.log('isIntersecting', run_one_func);
// 				if (run_one_func === 1) {
// 					// $('.ttl_pjax_anim').remove();
// 					$('body').addClass('js-pjax_anim_02-active');
// 					$('body').addClass('js-subpage_openring-active');
// 					let dataUrl = $('.js-next_page').data('url');
// 					let options = {
// 						url: dataUrl + '.html',
// 						container: '#pj-container',
// 						fragment: '#pj-container',
// 						scrollTo: 0,
// 					};
// 					if (timerID != null) {
// 						clearTimeout(timerID);
// 					}
// 					timerID = setTimeout(function () {
// 						if ($('.sp').length) {
// 							//***
// 							run_one_func = 2;
// 							// current_data = $('.js-next_page').data('link');
// 							// current_link = link_array[current_data].json;
// 							// pjax_anim_02_flag = 1;
// 							// pjax_anim_02(options);
// 							if (!$('.article_08').length) {
// 								// current_data = $('.js-next_page').data('link');
// 								// current_link = link_array[current_data].json;
// 								////ttl_pjax_anim(50);
// 							}
// 							setTimeout(() => {
// 								flag = 1;
// 							}, 1500);
// 							setTimeout(function () {
// 								$.pjax(options);
// 								scroll_Top = 0;
// 								run_one_func = 0;
// 								if ($('.article_08').length) {

// 									$('body').addClass('js-ttl_hidden');
// 								}
// 							}, 1550);
// 						}
// 					}, 50);

// 					if ($('.tablet').length && run_one_func === 1) {
// 						run_one_func = 2;
// 						// current_data = $('.js-next_page').data('link');
// 						// current_link = link_array[current_data].json;
// 						// pjax_anim_02_flag = 1;
// 						// pjax_anim_02(options);
// 						if (!$('.article_08').length) {
// 							// current_data = $('.js-next_page').data('link');
// 							// current_link = link_array[current_data].json;
// 							// //ttl_pjax_anim(50);
// 						}
// 						setTimeout(() => {
// 							flag = 1;
// 						}, 1500);

// 						setTimeout(function () {
// 							$.pjax(options);
// 							scroll_Top = 0;
// 							run_one_func = 0;
// 							if ($('.article_08').length) {

// 								$('body').addClass('js-ttl_hidden');
// 							}
// 						}, 1550);
// 					}
// 					if ($('.pc').length) {
// 						//***
// 						pjax_anim_02_flag = 1;
// 						// pjax_anim_02(options);
// 						if (!$('.article_08').length) {
// 							// current_data = $('.js-next_page').data('link');
// 							// current_link = link_array[current_data].json;
// 							//ttl_pjax_anim(50);
// 						}
// 						setTimeout(() => {
// 							flag = 1;
// 						}, 1500);
// 						setTimeout(function () {
// 							$.pjax(options);
// 							scroll_Top = 0;
// 							if ($('.article_08').length) {
// 								$('body').addClass('js-ttl_hidden');
// 							}
// 							run_one_func = 0;
// 						}, 1550);
// 					}
// 				}
// 			}
// 		});
// 	}
// }

// let article_num_array = {
// 	1: { src: 'sub_ttl_01.svg', srcset: 'sub_ttl_01_sp.svg' },
// 	2: { src: 'sub_ttl_02.svg', srcset: 'sub_ttl_02_sp.svg' },
// 	3: { src: 'sub_ttl_03.svg', srcset: 'sub_ttl_03_sp.svg' },
// 	4: { src: 'sub_ttl_04.svg', srcset: 'sub_ttl_04_sp.svg' },
// 	5: { src: 'sub_ttl_05.svg', srcset: 'sub_ttl_05_sp.svg' },
// 	6: { src: 'sub_ttl_06.svg', srcset: 'sub_ttl_06_sp.svg' },
// 	7: { src: 'sub_ttl_07.svg', srcset: 'sub_ttl_07_sp.svg' },
// 	8: { src: 'sub_ttl_08.svg', srcset: 'sub_ttl_08_sp.svg' },
// };
// const sub_page_ttlEv = () => {
// 	let article_num = $('#page_sub').attr('data-art-num');
// 	$('.a-sub_page_ttl.js-article_ttl')
// 		.children('img')
// 		.attr('src', 'assets/svg/' + article_num_array[article_num].src);
// 	$('.a-sub_page_ttl.js-article_ttl')
// 		.children('source')
// 		.attr('srcset', 'assets/svg/' + article_num_array[article_num].srcset);
// };

const card_acc_toggle = () => {
	//???pcにはないもので現在のdomにない カードのアコーディオン？
	$('.a-card_acc_toggle').on('click', function () {
		$(this).parents('div').toggleClass('js-acc_active');
		$(this).parents('.a-card_prof').find('.a-card_acc').slideToggle(500);
	});
};
/* Events trigger */

let next_url = null;
let ua = navigator.userAgent;
let bodyClass = document.body.classList;
var PageEvents = {
	commonFunc: () => {
		//ページ共通function
		//	console.log("common");
		if (
			ua.indexOf('iPhone') > 0 ||
			(ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)
		) {
			bodyClass.add('sp');
			if (ua.indexOf('iPhone') > 0) bodyClass.add('iphone');
			if (ua.indexOf('Android') > 0) bodyClass.add('android');
			card_acc_toggle();
		} else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
			bodyClass.add('tablet');
			if (ua.indexOf('iPad') > 0) bodyClass.add('ipad');
			if (ua.indexOf('Android') > 0) bodyClass.add('android');
			card_acc_toggle();
		} else {
			bodyClass.add('pc');
		}
		ResetStyle();
		menu_init();
		scroll_reset();
		Hover_ANIM_trigger();
		// page_anime_func();
		setTimeout(function () {
			Pjax_ANIM_BLKOUT(); //hayai?
		}, 300);
	},
	page_top_func: () => {
		//	topページのスライダーの読み込みを少し遅らせて、遷移アニメーション中に初期化が終わるように
		setTimeout(function () {
			slider_top();
		}, 600);
		const listeners = [['window', scroll]];
		OBSERVER.observeEvents(listeners);
	},
	page_about_func: () => {
		// about_swiper();
		$('.a-scrolltop img').on('click', function () {
			$('html,body').animate({ scrollTop: 0 }, 1500, 'swing');
		});
		// slider_anim_toggle = 'off';
		// if ($('.ttl_anim').length) {
		// 	$('.ttl_anim').remove();
		// }
		// if ($('.ttl_pjax_anim').length) {
		// 	$('.ttl_pjax_anim').remove();
		// }
		const listeners = [['.a-scrolltop img', 'click']];
		OBSERVER.observeEvents(listeners);
	},
	elseFunc: () => {
		// slider_anim_toggle = 'off';
		next_url = $('.m-next_mv').data('url');

		// if ($('.scrollEv_on').length) {
		// 	scrollEv();
		// }

		const listeners = [];
		OBSERVER.observeEvents(listeners);
	},
};
function pageCheck() {
	if (document.getElementById('page_top')) {
		// $('body').addClass('js-opening_anim-active');
		// setTimeout(() => {}, 120);
		PageEvents.page_top_func();
	} else if (document.getElementById('page_about')) {
		PageEvents.page_about_func();
	} else {
		PageEvents.elseFunc();
	}
	PageEvents.commonFunc();
}

let flag = 0;
function anime1(options) {
	// if ($('#ttl_anim_wrap').length) {
	// 	slider_ttl_anim(270);
	// }
	// pjax_anim_01(0);
	setTimeout(function () {//Pjax_ANIM_BLKINのcompleteに入れるべき（optionとかの引継ぎのリコードが必要かも）
		$.pjax(options);
		// $('body').addClass('js-ttl_hidden');
	}, 1000);
}
function anime2(options) {
	// pjax_anim_01(0);

	setTimeout(function () {
		$.pjax(options);
	}, 1000);

	// setTimeout(() => {
	// 	pjax_anim_02();
	// }, 1500);

	// $('.ttl_pjax_anim').remove();
	//ttl_pjax_anim(50);
}
function anime3(options) {
	// pjax_anim_ringOpen(0);
	//ttl_pjax_anim(50);
	//	console.log(options);

	setTimeout(function () {
		// $('#ttl_anim_wrap').remove();
		$.pjax(options);
	}, 1000);
	// $('#ttl_anim_wrap').fadeOut(1000, () => {
	// });

	flag = 1;
}

let popstateFlag = 0;
let popstate_scroll_reset = 0;
let pjclick = 0;
function init() {
	pjclick = 0;
		console.log("init");
	setTimeout(function () {
		Pjax_ANIM_BLKOUT(); //hayai?
	}, 300);
	$(document).on('click', '.pj', function (e) {
		//ページ遷移のもろもろ
		e.preventDefault();
		//遷移アニメーション開始
		PjaxAnimResetStyle();
		Pjax_ANIM_BLKIN();

		if ($(this).hasClass('to_about')) {
			//	console.log("to_about");
			let href = $(this).attr('href');
			let options = {
				// url: href,
				url: 'about.html',
				container: '#pj-container',
				fragment: '#pj-container',
			};
			anime1(options);
		} else if ($(this).hasClass('to_top')) {
			//	console.log("to_top");
			let options = {
				url: 'index.html',
				container: '#pj-container',
				fragment: '#pj-container',
			};
			anime1(options);
		} else if ($(this).hasClass('slide-clickable')) {
			//topのスライダークリックでの遷移
			pjclick = 1;
			// let href = $('.swiper-slide-active .slide-clickable').data('link');
			// let options = {
			// 	url: link_array[href]['url'],
			// 	container: '#pj-container',
			// 	fragment: '#pj-container',
			// };
			let href = $(this).attr('href');
			let options = {
				url: href,
				container: '#pj-container',
				fragment: '#pj-container',
			};
			//	console.log("pjclickanime3",options);
			anime3(options);
		} else if ($(this).hasClass('js_menu_link')) {
			// $('body').removeClass('js-ttl_hidden');
			pjclick = 1;
			// current_data = $(this).attr('data-link');
			// current_link = link_array[current_data].json;
			let href = $(this).attr('href');
			let options = {
				url: href,
				container: '#pj-container',
				fragment: '#pj-container',
			};

			//	console.log("pjclick",options);
			anime2(options);
		} else {
			let href = $(this).attr('href');
			let options = {
				url: href,
				container: '#pj-container',
				fragment: '#pj-container',
			};
			anime2(options);
		}
	});
	$(document).on('pjax:beforeSend', function () {
		//	console.log("pjax:beforeSend");

		if ($('.mv05').length) {
			top_swiper_destroy(mainSlider);
		}
	});
	$(document).on('pjax:popstate', function () {
		//	console.log("pjax:popstate");
		popstateFlag = 1;
		PjaxAnimResetStyle();
		Pjax_ANIM_BLKIN();
	});
	$(document).on('pjax:end', function () {
		//	console.log("pjax:end");
		innerHeight;
		// setTimeout(function () {
		// //	console.log("Ssssssssssssssss");
		// 	Pjax_ANIM_BLKOUT(); //hayai?
		//   }, 300);
		$('.css-vw_hidden').css('height', $(window).outerHeight());
		let options = 0;
		// if ($('#page_top').length) {
		// 	window.location.reload();
		// }
		if (popstate_scroll_reset === 1) {
			// $('.ttl_pjax_anim').remove();
			if ($('#page_about').length) {
				$('body').addClass('js-ttl_hidden');
			} else {
				$('.js-ttl_hidden').remove();
				// current_data = $('#page_sub').attr('data-link');
				// setTimeout(() => {}, 600);
				if (current_data == undefined) {
					window.location.reload();
				} else {
					// current_link = link_array[current_data].json;
					//ttl_pjax_anim(50);
				}
			}
			window.scrollTo(0, 0);
			popstate_scroll_reset = 0;
		}
		if ($('.js-pjax_pop').length) {
			setTimeout(() => {}, 600);
		} else {
			window.setTimeout(() => {
				$('body').removeClass('non-scrollable');

				$('body').removeClass('js-pjax_anim_02-active');
				$('body').removeClass('js-subpage_openring-active');
			}, 2000);
		}

		if ($('#page_about').length) {
		}

		if (!$('#page_top').length) {
			// $('.scroll_icon_svg').remove();
			// scroll_icon();
			if (!$('#page_about').length) {
				// scroll_icon_02();
			}
			if (popstateFlag === 1) {
				if ($('#page_about').length) {
					// about_swiper();
				}

				if ($('#page_sub').length) {
					// pjax_anim_02();
					// current_link = link_array[current_data].json;
				}
			}
		}

		if (
			!$('#page_about').length &&
			$('.a-sub_page_ttl.js-article_ttl').length
		) {
			// sub_page_ttlEv();
			// $('.js-article_ttl').fadeIn(50);
		}

		// if (flag === 1) {
		// 	setTimeout(() => {
		// 		// pjax_anim_02();
		// 		if ($('.pjax_anim_02').length) {
		// 			$('.pjax_anim_02').remove();
		// 		}
		// 	}, 1000);
		// 	slider_ttl_anim(50);
		// } else if (flag === 2) {
		// 	$('#page').animate({ opacity: 1, top: 0 }, function () {
		// 		flag = 0;
		// 	});
		// } else {
		// }
		if ($('.js-menu_active').length) {
			$('body').removeClass('js-menu_active');
		}
		pageCheck();
	});
}
$(function () {
	$('body').removeClass('preload');
	console.log("ssss");
	// $('.css-vw_hidden').css('height', $(window).outerHeight());
	pageCheck();
	init();

	// PjaxAnimResetStyle();
	// Pjax_ANIM_BLKIN();
	if ($('#page_about').length) {
		// about_swiper();//
	}
	if (!$('#page_top').length) {
		// scroll_icon();
		// if (!$('#page_about').length) {
		// 	scroll_icon_02();
		// }
	}
	if ($('#page_sub').length) {
		// if ($('.a-sub_page_ttl.js-article_ttl').length) {
		// 	sub_page_ttlEv();
		// }
		// pjax_anim_02();
	}
});

let link_array = [];
let json_array = [];
if (
	ua.indexOf('iPhone') > 0 ||
	(ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)
) {
	link_array = {
		default_op: { json: 'op_title_sp.json', url: '' },
		about: { json: 'op_title_sp.json', url: 'about.html' },
		slider_num_01: { json: 'loop_title01_sp.json', url: 'sub_page_01.html' },
		slider_num_02: { json: 'loop_title02_sp.json', url: 'sub_page_02.html' },
		slider_num_03: { json: 'loop_title03_sp.json', url: 'sub_page_03.html' },
		slider_num_04: { json: 'loop_title04_sp.json', url: 'sub_page_04.html' },
		slider_num_05: { json: 'loop_title05_sp.json', url: 'sub_page_05.html' },
		slider_num_06: { json: 'loop_title06_sp.json', url: 'sub_page_06.html' },
		slider_num_07: { json: 'loop_title07_sp.json', url: 'sub_page_07.html' },
		slider_num_08: { json: 'loop_title08_sp.json', url: 'sub_page_08.html' },
	};
	json_array = {
		ring_anim_01: 'op_ring_sp.json',
		slider_anim_01: 'loop_ring_sp.json',
		pjax_anim_01: 'next_page_sp.json',
		pjax_anim_02: 'ring_open_sp.json',
		pjax_anim_ringOpen: 'ring_open_sp.json',
		scroll_icon: 'scroll_icon.json',
	};
} else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
	if (ua.indexOf('iPad') > 0) bodyClass.add('ipad');
	if (ua.indexOf('Android') > 0) bodyClass.add('android');

	link_array = {
		default_op: { json: 'op_title.json', url: '' },
		about: { json: 'op_title_sp.json', url: 'about.html' },
		slider_num_01: { json: 'loop_title01_sp.json', url: 'sub_page_01.html' },
		slider_num_02: { json: 'loop_title02_sp.json', url: 'sub_page_02.html' },
		slider_num_03: { json: 'loop_title03_sp.json', url: 'sub_page_03.html' },
		slider_num_04: { json: 'loop_title04_sp.json', url: 'sub_page_04.html' },
		slider_num_05: { json: 'loop_title05_sp.json', url: 'sub_page_05.html' },
		slider_num_06: { json: 'loop_title06_sp.json', url: 'sub_page_06.html' },
		slider_num_07: { json: 'loop_title07_sp.json', url: 'sub_page_07.html' },
		slider_num_08: { json: 'loop_title08_sp.json', url: 'sub_page_08.html' },
	};
	json_array = {
		ring_anim_01: 'op_ring_sp.json',
		slider_anim_01: 'loop_ring_sp.json',
		pjax_anim_01: 'next_page_sp.json',
		pjax_anim_02: 'ring_open_sp.json',
		pjax_anim_ringOpen: 'ring_open_sp.json',
		scroll_icon: 'scroll_icon.json',
	};
} else {
	link_array = {
		default_op: { json: 'op_title.json', url: '' },
		about: { json: '', url: 'about.html' },
		slider_num_01: { json: 'loop_title01.json', url: 'sub_page_01.html' },
		slider_num_02: { json: 'loop_title02.json', url: 'sub_page_02.html' },
		slider_num_03: { json: 'loop_title03.json', url: 'sub_page_03.html' },
		slider_num_04: { json: 'loop_title04.json', url: 'sub_page_04.html' },
		slider_num_05: { json: 'loop_title05.json', url: 'sub_page_05.html' },
		slider_num_06: { json: 'loop_title06.json', url: 'sub_page_06.html' },
		slider_num_07: { json: 'loop_title07.json', url: 'sub_page_07.html' },
		slider_num_08: { json: 'loop_title08.json', url: 'sub_page_08.html' },
	};
	json_array = {
		ring_anim_01: 'op_ring.json',
		slider_anim_01: 'loop_ring.json',
		pjax_anim_01: 'next_page.json',
		pjax_anim_02: 'ring_open.json',
		pjax_anim_ringOpen: 'ring_open.json',
		scroll_icon: 'scroll_icon.json',
	};
}

function ResetStyle() {
	$('body').removeClass('is-op');
	$('body').removeClass('-menu_active');
	$('.-curtain_mask').removeAttr('style');
	$('.-curtain').removeAttr('style');
	$('.-curtain2').removeAttr('style');
}
function PjaxAnimResetStyle() {
	$('.-page_anim_slide').removeAttr('style');
	$('.-page_anim_blk').removeAttr('style');
}
function Pjax_ANIM_BLKIN() {
	console.log('Pjax_ANIM_BLKIN');

	let Pjax_ANIM_in = gsap.timeline({
		defaults: {
			duration: .05,
			// clipPath: 'inset(0 100% 0 0)',
			// ease: 'power1.Out',
		},
		// onComplete: Pjax_ANIM_BLKOUT()  //<<< だめっぽい
		onComplete: function () {
			// setTimeout(function () {
			//   ResetStyle();
			// }, 200);
		},
	});
	Pjax_ANIM_in.set('.-page_anim_blk', {
		duration: 0,
		//   left: 0,
		  //   xPercent: -100
		  
		//   clipPath: 'inset(0)',
		opacity:0,
		  clipPath: 'inset(0 100% 0 0)',
		})
		// .to('.-page_anim_blk', {
		// 	// xPercent: 0
		// 	// clipPath: 'inset(0 100% 0 0)',
		// 	duration: 0,
		// 	opacity: 1,
		// 	// clipPath: 'inset(0)',
		// },)
		.to('.-page_anim_blk', {
			// xPercent: 0
			// clipPath: 'inset(0 100% 0 0)',
			// duration: .2,
			opacity: 1,
			clipPath: 'inset(0 0 0 0)',
			// clipPath: 'inset(0)',
		})

		// .set('.-page_anim_slide', {
		// 	// delay: .4,
		// 	clipPath: 'inset(0 100% 0 0)',
		// 	// clipPath: 'inset(0 100% 0 0%)'
		// 	// clipPath: 'inset(0 0 0 100%)'
		// });
	//   .to('.-page_anim_slide', {
	//     duration: 0.3,
	//     clipPath: 'inset(0 0% 0 0%)'
	//   });
	return Pjax_ANIM_in;
}
function Pjax_ANIM_BLKOUT() {
	console.log('Pjax_ANIM_BLKOUT');
	//GSAP
	let Pjax_ANIM_out = gsap.timeline({
		defaults: { duration: 0.1, ease: 'power1.Out' },
		onComplete: function () {
			setTimeout(function () {
				Pjax_ANIM_YLWOUT();
				// $('body').addClass('is-op');
			}, 300); //500
		},
	});
	Pjax_ANIM_out.set('.-page_anim_blk', {
		duration: 0.1,
		clipPath: 'inset(0)',
		//   width: '100%',
		//   xPercent: 0
	})
		.to('.-page_anim_slide', {
			duration: 0,
			clipPath: 'inset(0 0 0 0)',
		})
		.to('.-page_anim_blk', {
			// xPercent: 102
			clipPath: 'inset(0 0 0 100%)',
		});
	return Pjax_ANIM_out;
}
function Pjax_ANIM_YLWOUT() {
	// console.log('Pjax_ANIM_YLWOUT');
	//GSAP
	let Pjax_ANIM_YLWOUT = gsap.timeline({
		defaults: { duration: 0, ease: 'power1.Out' },
	});
	Pjax_ANIM_YLWOUT.to('.-page_anim_slide', {
		duration: 0.2,
		clipPath: 'inset(0 0 0 100%)',
	}).set('.-page_anim_blk', {
		//次のINのために左側にクリップを寄せる
		// xPercent: 102
		clipPath: 'inset(0 100% 0 0)',
	});
	return Pjax_ANIM_YLWOUT;
}

// TOPのview more用のhoverフラグ
function Hover_ANIM_trigger() {
	$('.slide-clickable').on({
		mouseenter: function () {
			$('.content-wrapper').addClass('js-is-hover');
		},
		mouseleave: function () {
			$('.content-wrapper').removeClass('js-is-hover');
		},
	});
}
